<div [class]="'text-carusel '+ mode">
  <div [class]="'text-carusel-wrapper '+ mode">
    <div [class]="'text-carusel-container ' + mode" #HotNewsContainer [style.left]="currentLeft">
      <div *ngFor="let textItem of textList"
           [@TextBox]="textItem.state"
           [style.left]="textItem.left + 'px'"
           [ngClass]="{'text-content': true}" (click)="onGoTo(textItem)">

        <!--[@TextBox]="textItem.state"-->
        <h3>{{textItem.content[getLangId(currLang$)].title}}</h3>
        {{textItem.content[getLangId(currLang$)].descr}}</div>
    </div>
    <div class="list-indicator-container">
      <div *ngFor="let textItem of textList"
           (click) = onChangeState(textItem)
           [ngClass]="{'list-indicator': true, 'active': textItem.state == 'current'}"></div>
    </div>
  </div>
</div>
